import './Legend.scss';

import Dot, { DotProps } from 'components/Basic/Dot/Dot';
import { Typography } from '@trackman/web-shared-components';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export interface LegendItem {
  label: string;
  dotProps?: DotProps;
  icon?: React.ReactNode;
}

export interface LegendProps {
  items: LegendItem[];
  disableSorting?: boolean;
}

const Legend = ({ items, disableSorting = false }: LegendProps) => {
  const { t } = useTranslation();

  const sortedItems = useMemo(
    () => (disableSorting ? items : [...items].sort((a, b) => a.label.localeCompare(b.label))),
    [items, disableSorting]
  );

  return (
    <div className='Legend-container'>
      {sortedItems.map((item) => (
        <div key={item.label} className='Legend-item'>
          {item.dotProps && <Dot {...item.dotProps} />}
          {item.icon && item.icon}
          <Typography className='Legend-item-label' component='div' variant='label'>
            {t(item.label)}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default Legend;
